module.exports = "/public/webpack/img/icon_help_categories_contents_326d63527fab15e4e8b4f82a0ed4e9bd8f.png";